import { render, staticRenderFns } from "./InquiryAnswerFileUploader.vue?vue&type=template&id=a029d674&"
import script from "./InquiryAnswerFileUploader.vue?vue&type=script&lang=ts&"
export * from "./InquiryAnswerFileUploader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VRow,VSimpleTable})
